import { patch as patchKeyword } from 'redux/keyword/actions';
import { createCollectionActions } from 'utils/actionsGenerator';

import {
    types,
    STOP_TRACKING_KEYWORDS,
    STOP_TRACKING_KEYWORDS_FAIL,
    STOP_TRACKING_KEYWORDS_SUCCESS,
} from './reducer';

export const { post } = createCollectionActions({
    name: 'keywords',
    types,
    url: '/keywords',
});

export function stopTrackingKeywords(keywords) {
    return (dispatch) => {
        const keywordId = keywords.first().get('id');

        if (keywords && keywords.size > 1) {
            const multiPatch = {};

            keywords.forEach((keyword) => {
                multiPatch[keyword.get('id')] = { active: false };
            });

            return dispatch({
                payload: {
                    request: {
                        data: { multiPatch },
                        method: 'patch',
                        url: `/keywords/${keywordId}`,
                    },
                },
                types: [
                    STOP_TRACKING_KEYWORDS,
                    STOP_TRACKING_KEYWORDS_SUCCESS,
                    STOP_TRACKING_KEYWORDS_FAIL,
                ],
            });
        } else if (keywords.size === 1) {
            return dispatch(
                patchKeyword(keywordId, { active: false })
            );
        }

        return Promise.resolve();
    };
}
